<script>
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import {LMap, LTileLayer, LMarker, LPopup, LIcon} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import {mapActions, mapGetters, mapState} from "vuex";
import EinspeisebeteiligungFile from "@/components/ui/einspeisebeteiligung/EinspeisebeteiligungFile.vue";
import EinspeisebeteiligungHeader from "@/components/ui/einspeisebeteiligung/EinspeisebeteiligungHeader.vue";
import EinspeisebeteiligungPayments from "@/components/ui/einspeisebeteiligung/EinspeisebeteiligungPayments.vue";
import EinspeisebeteiligungContactForm from "@/components/ui/einspeisebeteiligung/EinspeisebeteiligungContactForm.vue";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
export default {
  name: "Einspeisebeteiligung",
  props: ['service'],
  components: {
    Breadcrumbs,
    EinspeisebeteiligungContactForm,
    EinspeisebeteiligungPayments,
    EinspeisebeteiligungHeader,
    RightColumnGroup,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    EinspeisebeteiligungFile,
  },
  methods: {
    ...mapActions('einspeisebeteiligung', ['loadAnlagen', 'loadDocuments', 'downloadFile']),

  },
  mounted() {
    this.loadAnlagen();
    this.loadDocuments();
  },
  data: () => ({
    header: require("@/assets/einspeisebeteiligung.png"),
    mapConfig: {
      zoom: 12,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    },
    iconUrl: require("../../public/img/map-marker.png"),
    selectedDocumentType: 'Alle Dokumente',
    selectedDocumentYear: 'Alle Jahre',
    showContactDialog: false,
    contactFormName: '',
    contactForm: {
      submitted: false,
      name: '',
      phone: '',
      mail: '',
      message: '',
    }
  }),
  watch: {
    showContactDialog(val) {
      if (!val) {
        this.contactForm = {
          submitted: false,
          name: '',
          phone: '',
          mail: '',
          message: '',
        };
      }
    }
  },
  computed: {
    ...mapState('einspeisebeteiligung', ['anlagen', 'documents']),
    ...mapGetters('einspeisebeteiligung', ['anlagenForLatestYear', 'documentYears', 'documentTypes']),
    ...mapGetters('user', [
      'userCommuneLocation',
      'userCommuneName',
      'userEnabledEinspeisebeteiligung',
      'userCommunePartner',
      'userCommuneRegionalLeader',
    ]),

    mapCenter() {
      const commune = this.userCommuneLocation;

      return [parseFloat(commune.latitude), parseFloat(commune.longitude)];
    },
    mapStyle() {
      return {
        height: '660px',
        zIndex: 0,
      };
    },
    filteredDocuments() {
      return this.documents
          .filter((document) =>  this.selectedDocumentType === 'Alle Dokumente' || this.selectedDocumentType === document.dokumenttyp)
          .filter((document) => this.selectedDocumentYear === 'Alle Jahre' || this.selectedDocumentYear === document.jahr);
    },
    subtitle() {
      if(this.userEnabledEinspeisebeteiligung) return "Finanzielle Beteiligung an Windenergie- und PV-Freiflächenanlagen";
      else return `Für ${this.userCommuneName} existiert noch keine Einspeisebeteiligung.`;
    }
  }
}
</script>

<template>
  <v-row no-gutters class="min-height-100">
    <v-col cols="12" sm="8" class="new-wrapper py-10">
      <breadcrumbs />
      <div class="custom-header-text new-font-bold mb-5 px-5">Einspeisebeteiligung</div>
      <einspeisebeteiligung-header v-if="anlagen && userEnabledEinspeisebeteiligung" />
      <div class="px-5 mt-4">
        <p class="font-weight-bold einspeisebeteiligung-headline">{{ subtitle }}</p>
        <p>
          Durch die Energiewende werden vermehrt Windtürme und PV-Freiflächenanlagen gebaut. Nach § 6 EEG können wir
          {{ userCommuneName }} an den Erträgen von Wind- und PV-Freiflächenanlagen finanziell beteiligen. <br>
          <br>
          Für die eingespeiste Strommenge erhält {{ userCommuneName }} 0,2 Cent pro kWh (ohne Umsatzsteuer). <br>
          <br>
          Bedingung für die Beteiligung:
        </p>
        <ul>
          <li>Die Windanlage liegt im Umkreis von 2,5 km zur Gemeinde oder</li>
          <li>Die PV-Freiflächenanlage befindet sich auf dem Boden der Gemeinde</li>
        </ul>
        <br>
        <template v-if="!userEnabledEinspeisebeteiligung">
          <p>
            Möchten Sie überprüfen lassen, ob auch für {{ userCommuneName }} eine finanzielle Beteiligungsmöglichkeit durch die
            NEW nach §6 EEG für Wind- und/oder PV-Freiflächenanlagen besteht?
          </p>
          <EinspeisebeteiligungContactForm />
        </template>

        <template v-if="anlagen && userEnabledEinspeisebeteiligung">
          <einspeisebeteiligung-payments />
          <p class="font-weight-bold mt-5 mb-1 einspeisebeteiligung-headline">Standorte</p>
          <l-map :style="mapStyle" class="mt-4" :zoom="mapConfig.zoom" :center="mapCenter">
            <l-tile-layer :url="mapConfig.url" :attribution="mapConfig.attribution"></l-tile-layer>
            <l-marker v-for="anlage in anlagenForLatestYear" :key="anlage.id" :lat-lng="[anlage.Latitude, anlage.Longitude]">
              <l-icon icon-url="/img/map-marker.png" :icon-size="[46, 52]" :icon-anchor="[23, 52]"></l-icon>
              <l-popup>
                <p class="font-weight-bold primary-text my-0">{{anlage.Name}}</p>
                <p class="my-0">{{ anlage.Eigentuemer }}</p>
              </l-popup>
            </l-marker>
          </l-map>
        </template>
        <template v-if="documents && userEnabledEinspeisebeteiligung">
          <p class="font-weight-bold mt-5 mb-1 einspeisebeteiligung-headline">Dokumente</p>
          <p>Alle Dokumente zu Ihrer Einspeisebeteiligung an einem Ort. Über neue Dokumente werden Sie wie gehabt per E-Mail informiert.</p>
          <v-row>
            <v-col cols="12" md="6">
              <v-select :items="documentTypes"
                        dense
                        background-color="#f6e4ed"
                        outlined
                        v-model="selectedDocumentType"
                        hide-details
                        single-line />
            </v-col>
            <v-col cols="12" md="6">
              <v-select :items="documentYears"
                        dense
                        background-color="#f6e4ed"
                        outlined
                        v-model="selectedDocumentYear"
                        hide-details
                        single-line />
            </v-col>
          </v-row>
          <einspeisebeteiligung-file v-for="document in filteredDocuments" :key="document.osid" :document="document" />
        </template>
      </div>
    </v-col>
    <v-col cols="12" sm="4" class="contact_container pl-4">
      <RightColumnGroup
        :commune-partner="userCommunePartner"
        :commune-regional-leader="userCommuneRegionalLeader"
        :content-object="service"
      />
    </v-col>
  </v-row>
</template>

<style scoped>


.register-sheet p {
  font-size: 16px;
}

.einspeisebeteiligung-headline {
  padding-top: 30px;
}
</style>
